﻿<script setup lang="ts">
    import { ref, computed } from 'vue';

    const props = defineProps<{ active: boolean }>();
    const emit = defineEmits<{
        create: [info: NewRevisionInfo];
        cancel: [];
    }>();

    const name = ref<string>('');
    const description = ref<string>('');

    const canSave = computed(() => {
        return name.value.trim().length > 0;
    });

    // Type for confirm event payload
    export interface NewRevisionInfo {
        name: string;
        description: string;
    }

    function onCreate() {
        emit('create', { name: name.value, description: description.value });
        resetValues();
    }
    function onCancel() {
        emit('cancel');
        resetValues();
    }
    function resetValues() {
        name.value = '';
        description.value = '';
    }
</script>

<template>
    <b-modal
        :model-value="props.active"
        @close="onCancel">
        <div class="box">
            <h3 class="title is-5">
                New Revision
            </h3>
            <b-field label="Name">
                <b-input
                    v-model="name"
                    placeholder="Revision name" />
            </b-field>
            <b-field label="Description">
                <b-input
                    v-model="description"
                    placeholder="Revision description" />
            </b-field>
            <div class="buttons is-right">
                <b-button @click="onCancel">
                    Cancel
                </b-button>
                <b-button
                    :disabled="!canSave"
                    type="is-primary"
                    @click="onCreate">
                    Create
                </b-button>
            </div>
        </div>
    </b-modal>
</template>
